module.exports = __webpack_public_path__ + "img/framework.b6a65f22.png";